import { isAfter } from 'date-fns'
import * as yup from 'yup'
import _ from 'lodash'

import { FILE_SIZE, SUPPORTED_FORMATS } from '~/constants/image'

export function urlTest(url) {
  try {
    if (!url) return true
    return !!new URL(url)
  } catch {
    return false
  }
}

export const requiredMessage = 'This field is required'
const shape = obj => yup.object().shape(obj)
const validations = {
  media: yup
    .mixed()
    .test(
      'fileSize',
      'File size too large (Max: 5Mb)',
      value => value && value.size <= FILE_SIZE
    )
    .test(
      'fileFormat',
      'Unsupported format',
      value => value && SUPPORTED_FORMATS.includes(value.type)
    ),
  event: shape({
    title: yup.string().required(requiredMessage),
    schedule: shape({
      startDateTime: yup
        .string()
        .required(requiredMessage)
        .test('after-end', 'Start must be before the end', function (start) {
          const end = this.parent.endDateTime
          if (!start) return false
          return isAfter(new Date(end), new Date(start))
        }),
      endDateTime: yup
        .string()
        .required(requiredMessage)
        .test('before-start', 'End must be after the start', function (end) {
          const start = this.parent.startDateTime
          if (!end) return false
          return isAfter(new Date(end), new Date(start))
        }),
    }),
  }),
  callToAction: shape({
    actionType: yup.object().nullable(),
    url: yup
      .string()
      .test('is required', requiredMessage, function (url) {
        const { actionType } = this.parent
        if (!actionType?.value || actionType?.value === 'CALL') return true
        return !_.isEmpty(url)
      })
      .test('valid url', 'Invalid URL', urlTest),
  }),
  requiredCallToAction: shape({
    actionType: yup.object().required(requiredMessage),
    url: yup
      .string()
      .test('valid url', 'Invalid URL', urlTest)
      .required(requiredMessage),
  }),
  summary: yup.string(),
  locationNames: yup
    .array()
    .min(1, 'You must select some location to post')
    .of(yup.string()),
  schedulePost: yup.number().nullable(),
  offer: shape({
    couponCode: yup.string(),
    redeemOnlineUrl: yup.string().test('valid url', 'Invalid URL', urlTest),
    termsConditions: yup.string(),
  }),
}

export default validations
